'use es6';

export function getWindowSearch() {
  return window.location.search;
}